<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      :title="title"
      width="70%"
      @close="close"
    >
      <vab-query-form class="vab-query-form">
        <vab-query-form-left-panel :span="4">
        </vab-query-form-left-panel>
        <vab-query-form-right-panel :span="20">
          <el-form :inline="true" :model="queryForm" @submit.prevent>
            <el-form-item label="">
              <el-input
                v-model.trim="queryForm.keyword"
                class="pr-10"
                clearable
                placeholder="关键词"
              />
            </el-form-item>
            <!--
            <el-form-item label="">
              <el-select v-model="queryForm.command" class="pr-10" placeholder="操作类型" clearable>
                <el-option
                  v-for="item in commandOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          -->
            <el-form-item label="" class="pr-10">
              <el-date-picker
                v-model="queryForm.startTime"
                type="datetime"
                placeholder="开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-date-picker
                v-model="queryForm.endTime"
                type="datetime"
                placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" @click="queryData">
                查询
              </el-button>
              <!--
              <el-button icon="el-icon-download" type="warning" :loading="exportLoading" @click="exportData">
                导出
              </el-button>
              -->
            </el-form-item>
          </el-form>
        </vab-query-form-right-panel>
      </vab-query-form>
      <el-table v-loading="listLoading" stripe :data="list">
        <el-table-column align="left" label="序号" width="55">
          <template #default="{ $index }">
            {{ $index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="设备标题"
          prop="basic.deviceTitle"
          width="180"
          show-overflow-tooltip
        />
        <el-table-column
          align="left"
          label="类型"
          prop="basic.method"
          width="100"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <el-tag v-if="row.basic.method == 'send'">发送</el-tag>
            <el-tag v-else type="info">接收</el-tag>
            <!--<span v-else>接收</span>-->
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="action"
          width="100"
          prop="basic.action"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            {{ row.basic.method == 'send' ? (row.basic.action === '' ? '查询' : (row.basic.action > 0 ? `启动:${row.basic.action}` : '停止')) : row.basic.action }}
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="lock"
          width="100"
          prop="basic.lock"
          show-overflow-tooltip
        />
        <el-table-column
          align="left"
          label="内容"
          prop="basic.text"
          show-overflow-tooltip
        />
        <el-table-column
          align="left"
          label="记录时间"
          width="180"
          prop="created"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          fixed="right"
          label="操作"
          show-overflow-tooltip
          width="100px"
        >
          <template #default="{ row }">
            <el-button type="text" class="mr-10" @click="handleShow(row)">
              详情
            </el-button>
          </template>
        </el-table-column>
        <template #empty>
          <el-image
            class="vab-data-empty"
            :src="require('@/assets/empty_images/data_empty.png')"
          />
        </template>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.size"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />

      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
    <log-detail ref="detail" />
  </div>
</template>

<script>
import moment from 'moment'
import config from './config'
import LogDetail from './logDetail.vue'
import { findDevice, findDeviceLogList, exportDeviceLog } from '@/api/alfmeier'
export default {
  name: 'AlfmeierDeviceLog',
  emits: ['fetch-data'],
  components: { LogDetail },
  data() {
    return {
      moment,
      showForm: {},
      list: [],
      total: 0,
      layout: 'total, sizes, prev, pager, next, jumper',
      listLoading: true,
      exportLoading: false,
      row: {},
      dialogFormVisible: false,
      commandOptions: config.commands,
      queryForm: {
        deviceId: '',
        page: 1,
        size: 10,
        startTime: '',
        endTime: '',
        keyword: ''
      },
    }
  },
  methods: {
    handleShow(row) {
      this.$refs['detail'].show(row)
    },
    formatMethod(row) {
      return row.basic.method == 'send' ? '发送' : '接收'
    },
    formatPlace(row) {
      const find = config.places.find(e => e.value == row.basic.place)
      return find && find.label || '未知'
    },
    formatPower(row) {
      const find = config.powers.find(e => e.value == row.basic.power)
      return find && find.label || '未知'
    },
    formatCommand(row) {
      const find = config.commands.find(e => e.value == row.basic.command)
      return find && find.label || '未知'
    },
    async showLog(row) {
      const deviceId = row.deviceId
      this.row = row
      const data = await findDevice({
        deviceId,
        simple: 1,
      })
      this.title = data.title
      this.showForm = data
      this.queryForm.deviceId = deviceId
      this.dialogFormVisible = true
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const data = Object.assign({}, this.queryForm)
      if(data.startTime)
        data.startTime = data.startTime.valueOf()
      if(data.endTime)
        data.endTime = data.endTime.valueOf()
      const { list, total } = await findDeviceLogList(data)
      this.list = list
      this.total = total
      this.listLoading = false
    },
    async exportData() {
      this.exportLoading = true
      const data = Object.assign({}, this.queryForm)
      if(data.startTime)
        data.startTime = data.startTime.valueOf()
      if(data.endTime)
        data.endTime = data.endTime.valueOf()
      const ret = await exportDeviceLog(data)
      this.exportLoading = false
      if(ret && ret.url){
        this.$alert(`下载地址：${ret.url}`, '设备硬件日志导出', {
          confirmButtonText: '立即下载',
          callback: action => {
            window.location.href = ret.url
          }
        })
      }
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.vab-query-form {
  padding: 0;
}
</style>
